<mat-card
  class="item-card"
  [class.selected]="selectedItemId === item.id"
  [style.margin-left.px]="item.indentLevel * 24"
  [id]="'template-item-' + item.id"
  (click)="selectItem(item.id); $event.stopPropagation()"
  cdkDrag
  [cdkDragData]="item"
>
  <div class="item-drag-handle" cdkDragHandle>
    <mat-icon>drag_indicator</mat-icon>
  </div>

  <span #headerMarkerRef style="height: 1px"></span>
  <mat-card-header [class.sticky-header]="isHeaderSticky()">
    <div class="item-header-wrapper">
      <div class="item-title-row">
        <div class="item-number-badge" [class.selected]="selectedItemId === item.id">
          {{ item.itemNumber }}
        </div>
        @if (isEditingTitle) {
          <input
            #titleInput
            type="text"
            class="item-title-input"
            [(ngModel)]="temporaryTitle"
            (blur)="onTitleFocusLoss()"
            (keydown)="onTitleKeydown($event)"
            (click)="$event.stopPropagation()"
          />
        } @else {
          <div class="item-title" (click)="onTitleClick(); $event.stopPropagation()">
            {{ item.title }}
          </div>
        }

        <div class="header-actions">
          <!-- <button mat-icon-button (click)="editItem(); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button> -->
          <button mat-icon-button (click)="toggleExpanded(); $event.stopPropagation()">
            <mat-icon>{{ item.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
      </div>
      <div class="item-metadata-row" [class.has-indent]="item.indentLevel > 0">
        @if (!item.expanded) {
          <span class="metadata-item" [matTooltip]="blocksTooltip" [matTooltipShowDelay]="0">
            <mat-icon>layers</mat-icon>
            {{ numberOfBlocks }}
          </span>
          @if (numberOfAttachments > 0) {
            <span class="metadata-item" [matTooltip]="attachmentsTooltip" [matTooltipShowDelay]="0">
              <mat-icon>attach_file</mat-icon>
              {{ numberOfAttachments }}
            </span>
          }
        }
        @if (item.duration) {
          <span class="metadata-item" [matTooltip]="'TEMPLATES.EDITOR.DURATION_TOOLTIP' | translate" [matTooltipShowDelay]="0">
            <mat-icon>schedule</mat-icon>
            {{ item.duration }} {{ 'TEMPLATES.EDITOR.MINUTES_SUFFIX' | translate }}
          </span>
        }
        @if (!item.expanded) {
          @if (item.presenters.length > 0) {
            <span class="metadata-item" [matTooltip]="'TEMPLATES.EDITOR.PRESENTERS_TOOLTIP' | translate" [matTooltipShowDelay]="0">
              <mat-icon>people</mat-icon>
              {{ item.presenters.join(', ') }}
            </span>
          }
        }
        @if (!item.expanded && shouldShowTimelineBar) {
          <div class="timeline-bar-container" [matTooltip]="timelineTooltip" matTooltipClass="multiline-tooltip">
            <div class="timeline-bar">
              @for (segment of item.minuteTimelineSegments; track $index) {
                <div class="timeline-segment" [ngStyle]="getSegmentStyle(segment)"></div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </mat-card-header>

  @if (item.expanded) {
    <mat-card-content>
      <div class="content-blocks-section">
        <h4><mat-icon>layers</mat-icon>{{ 'TEMPLATES.EDITOR.CONTENT_BLOCKS' | translate }}</h4>
        @if (item.contentBlocks.length === 0) {
          <div class="no-blocks-container">
            <p class="no-blocks">{{ 'TEMPLATES.EDITOR.NO_CONTENT_BLOCKS' | translate }}</p>
            <ng-container [ngTemplateOutlet]="addBlockDivider" [ngTemplateOutletContext]="{ index: 0 }" />
          </div>
        } @else {
          <ng-container class="first-block-divider" [ngTemplateOutlet]="addBlockDivider" [ngTemplateOutletContext]="{ index: 0 }" />

          <div cdkDropList (cdkDropListDropped)="onBlockDrop($event)" class="blocks-drop-list">
            @for (block of item.contentBlocks; track block.id; let blockIndex = $index) {
              <app-template-item-content-block
                cdkDrag
                [block]="block"
                [availableResources]="availableResources"
                [allowFileUpload]="allowFileUpload"
                [shouldFocus]="blockIdToFocus === block.id"
                [superModeEnabled]="superModeEnabled"
                (contentChanged)="markAsChanged()"
                (blockRemoved)="removeContentBlock($event)"
                (fileUploadRequested)="onFileUploadRequested($event)"
                (pdfPreviewRequested)="onPdfPreviewRequested($event)"
              />
              <ng-container [ngTemplateOutlet]="addBlockDivider" [ngTemplateOutletContext]="{ index: blockIndex + 1 }" />
            }
          </div>
        }
      </div>

      <div class="presenters-section">
        <h4><mat-icon>groups</mat-icon>{{ 'TEMPLATES.EDITOR.PRESENTERS' | translate }}</h4>

        @if (item.presenters.length > 0) {
          <div class="presenters-list">
            @for (presenter of item.presenters; track $index) {
              <mat-chip [removable]="true" (removed)="removePresenter($index)">
                {{ presenter }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            }
          </div>
        }

        <div class="add-presenter-input">
          <mat-form-field appearance="outline" class="presenter-input">
            <input
              matInput
              placeholder="{{ 'TEMPLATES.EDITOR.ENTER_PRESENTER_NAME' | translate }}"
              [(ngModel)]="newPresenterName"
              [matAutocomplete]="presenterAutocomplete"
              (focus)="filterAttendeeNames()"
              (input)="filterAttendeeNames()"
              (keydown.enter)="addPresenter(newPresenterName); $event.stopPropagation()"
              (click)="$event.stopPropagation()"
            />
            <mat-autocomplete #presenterAutocomplete="matAutocomplete" (optionSelected)="addPresenter($event.option.value)">
              @for (attendeeName of filteredAttendeeNames; track attendeeName) {
                <mat-option [value]="attendeeName">
                  {{ attendeeName }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <button mat-stroked-button (click)="addPresenter(newPresenterName); $event.stopPropagation()" [disabled]="newPresenterName.trim() === ''">
            {{ 'TEMPLATES.EDITOR.ADD' | translate }}
          </button>
        </div>
      </div>
    </mat-card-content>
  }

  <div class="item-drag-placeholder"></div>

  <span #cardMarkerRef class="sticky-header-card-marker"></span>
</mat-card>

<ng-template #addBlockDivider let-index="index">
  <div class="add-block-divider" [class.first-block-divider]="index === 0" (click)="menuTrigger.openMenu(); $event.stopPropagation()">
    <div class="divider-line"></div>
    <button mat-icon-button class="add-block-button" [matMenuTriggerFor]="addBlockMenu" #menuTrigger="matMenuTrigger" (click)="$event.stopPropagation()">
      <mat-icon>add</mat-icon>
    </button>
    <div class="divider-line"></div>
  </div>
  <mat-menu #addBlockMenu="matMenu">
    <button mat-menu-item (click)="addContentBlock(TemplateContentBlockType.FIXED_TEXT, index, null)">
      <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.FIXED_TEXT' | translate }}</span>
    </button>
    <button mat-menu-item (click)="addContentBlock(TemplateContentBlockType.VARIABLE_TEXT, index, null)">
      <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.VARIABLE_TEXT' | translate }}</span>
    </button>
    <div
      [matTooltip]="hasDiscussionSummaryBlock ? ('TEMPLATES.EDITOR.BLOCK_ALREADY_EXISTS' | translate) : ''"
      [matTooltipDisabled]="!hasDiscussionSummaryBlock"
    >
      <button mat-menu-item [disabled]="hasDiscussionSummaryBlock" (click)="addContentBlock(TemplateContentBlockType.DISCUSSION_SUMMARY, index, null)">
        <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.DISCUSSION_SUMMARY' | translate }}</span>
      </button>
    </div>
    <button mat-menu-item [matMenuTriggerFor]="binarySubMenu">
      <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.BINARY' | translate }}</span>
    </button>
  </mat-menu>
  <mat-menu #binarySubMenu="matMenu">
    <div [matTooltip]="hasMattersArisingBlock ? ('TEMPLATES.EDITOR.BLOCK_ALREADY_EXISTS' | translate) : ''" [matTooltipDisabled]="!hasMattersArisingBlock">
      <button mat-menu-item [disabled]="hasMattersArisingBlock" (click)="addContentBlock(TemplateContentBlockType.MATTERS_ARISING, index, null)">
        <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.MATTERS_ARISING' | translate }}</span>
      </button>
    </div>
    <mat-divider />
    <button mat-menu-item (click)="addContentBlock(TemplateContentBlockType.BINARY, index, null)">
      <span>{{ 'TEMPLATES.EDITOR.BLOCK_TYPES.BINARY_CUSTOM' | translate }}</span>
    </button>
    <mat-divider />
    @for (subCategory of binarySubCategories; track subCategory) {
      <button mat-menu-item (click)="addContentBlock(TemplateContentBlockType.BINARY, index, subCategory)">
        <span>{{ 'CALLS.AGENDA_EDITOR.SUB_CATEGORIES.' + subCategory | translate }}</span>
      </button>
    }
  </mat-menu>
</ng-template>
